<template>
  <v-dialog persistent max-width="700px" v-model="visible">
    <v-card>
      <v-form ref="form" :lazy-validation="true">
        <v-card-title>
          <h4>NY ANTECKNING</h4>
          <v-card-actions>
            <v-icon class="close" @click="close()">$sl-close</v-icon>
          </v-card-actions>
        </v-card-title>

        <v-card-text>
          <v-textarea
            outlined
            v-model="note.data"
            label="Anteckning"
            rows=10
            :rules="[rules.required]"
          ></v-textarea>

          <template v-if="!isCompanyNote">
            <div class="sub-title">KOPPLA ÄRENDEN</div>
  
            <v-select
              label="Lärlingsanmälan"
              v-model="application"
              :items="applications"
              clearable
              :disabled="Boolean(applicationId)"
              >
            </v-select>
          </template>
        </v-card-text>

        <v-card-actions class="d-flex justify-end">
          <v-btn outlined @click="close()" ><v-icon>$sl-cancel</v-icon>Avbryt</v-btn>
          <v-btn @click="saveNote"><v-icon>$sl-check</v-icon>Spara</v-btn>
        </v-card-actions>

      </v-form>
    </v-card>
  </v-dialog>  
</template>

<script>
import API from "@/services/api.js"
import {RulesMixin} from '@/components/mixins'

export default {

  mixins: [RulesMixin],

  props: {
    value: {
      type: Boolean
    },
    personId: {
      type: Number
    },
    applicationId: {
      type: Number
    },
    isCompanyNote: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    visible: false,
    note: {},
    applications: [],
    application: null
  }),

  watch: {
    value: {
      handler: function(val) {
        this.visible = val
        if (val) {
          this.note = {}
          this.application = this.applicationId ? this.applicationId : {}
          this.fetchApplications()
          if (this.$refs.form) {
            this.$refs.form.resetValidation()
          }
        }
      }
    }
  },

  computed: {
  },

  methods: {
    saveNote() {
      //- Trigger validations and bug out on invalid
      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
        return
      }

      let data = this.note

      data.ownerId = this.personId

      //- Deafult on personId
      data.noteableId = this.personId
      data.noteableType = 'Person'

      if (! isNaN(this.application)) {
        data.noteableId = this.application
        data.noteableType = 'Application'
      }

      if ( this.isCompanyNote ) {
        data.ownerId = this.$route.params.id
        data.noteableId = this.$route.params.id
        data.noteableType = 'Company'
      }

      API.createNote({data})
        .then(res => {
          this.$emit('input', false)
          this.$emit('saved')
          this.visible=false
        })
        .catch(e => {
          this.$fire('showError', 'Kunde inte skapa ny anteckning')
        })
    },

    close() {
      this.$emit('input', false)
      this.visible=false
    },

    async fetchApplications() {
      if ( this.isCompanyNote ) return
      
      const person = await API.getPerson(this.personId)
      if (!person.data) return

      API.listApplications({
        startAt: 0,
        sortBy: "lastName",
        sortDesc: "ASC",
        advSearch: { personalNumber: person.data.personalNumber },
        pageSize: 1000,
      })
        .then((response) => {
          this.applications = response.data.rows.map(o => { return {value: o.id, text: `Lärlingsanmälan ${o.id}`} } )
        })
        .catch(e => {
          console.log(e)
        })

    }
  }

}
</script>

<style>
  .sub-title {
    font-family: "Dosis", sans-serif !important;
    font-size: 18px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: 0.56px;
    color: var(--color-03-on-primary-a-high-emphasis);
  }

</style>